import { useParams } from "react-router";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";
import {
  MilestonePage,
  MilestonePageContent,
} from "@/shared/service-manager/default-ui/milestone-page/milestone-page";
import { ReportListTable } from "./report-list-table";

export function ReportsIndexRoute() {
  const { processId } = useParams();
  const { notReadyError } = useErrArtefactNotReady();

  return (
    <MilestonePage>
      <MilestonePageContent>
        <ArtefactNotReadyAlert error={notReadyError} artefact="Inspektion" />
        <ReportListTable processId={processId!} />
      </MilestonePageContent>
    </MilestonePage>
  );
}
